import React, { useEffect, useCallback, useState, useRef } from 'react';
import { Layout, Menu, Button, Dropdown, Drawer, Radio, MenuProps, Typography, Avatar, Badge, notification } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined, UserOutlined, SolutionOutlined, LogoutOutlined, MobileOutlined, MessageOutlined, TeamOutlined, MenuOutlined, FileTextOutlined, LineChartOutlined, WhatsAppOutlined, ToolOutlined, SettingOutlined, FileProtectOutlined, RobotOutlined } from '@ant-design/icons';
import { FaSitemap, FaCog, FaUnlockAlt, FaTv, FaRegListAlt, FaListAlt, FaUserAlt, FaLockOpen, FaLandmark, FaDollarSign, FaPlusCircle, FaCreditCard } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '@ant-design/icons';
import axios from 'axios';

import { stateGlobal } from '../../interfaces/Global';

import * as GlobalActions from '../../store/modules/global/actions';
import * as LoginActions from '../../store/modules/login/actions';

import { getUsuario } from '../../services/token/usuario';
import { getMensagensWhatsAppAbertas } from './requests/quantidadesMensagensWhatsApp';
import { getQuantidadesReceitasIPM } from './requests/quantidadesReceitasIPM';
import { getSolicitacoesNaoAtendidas } from './requests/quantidadesSolicitacoesNaoAtendidas';
import { getQuantidadeSolicitacaoReceitas } from './requests/quantidadesSolicitacoesReceitas';
import { getQuantidadesSolicitacoesSaldoDeContas } from './requests/quantidadesSolicitacoesSaldoDeContas';
import { getQuantidadesContasACadastrarSaldoDeContas } from './requests/quantidadesContasACadastrarSaldoDeContas';
import { getQuantidadesFontesACadastrarSaldoDeContas } from './requests/quantidadesFontesACadastrarSaldoDeContas';
import { getQuantidadesInvestimentosACadastrarSaldoDeContas } from './requests/quantidadesInvestimentosACadastrarSaldoDeContas';

import LogoPNG from './../../assets/pngs/solicitacao_upgrade.png';
import { ReactComponent as FaPenSquare } from '../../assets/imagsIconesModulos/pen-to-square.svg';
import ImagemGovfacil from './../../assets/govfacil_logo.png';
import ImagemLogo from '../../assets/logo.png';
import ImagemLogoDark from '../../assets/logo_dark.png';
import ImagemIcone from '../../assets/icone.png';

import './style.css';

interface IBadgesLayout {
    quantidadeMsgAbertas: number | null,
    quantidadeReceitaIPM: number | null,
    quantidadeSolicitacoes?: number,
    quantidadeSolicitacoesRecetias: number | null,
    quantidadeSolicitacoesSaldoDeContas: number | undefined,
    quantidadeContasACadastrarSaldoDeContas: number | undefined,
    quantidadeFontesACadastrarSaldoDeContas: number | undefined,
    quantidadeInvestimentosACadastrarSaldoDeContas: number | undefined,
}

const { Text } = Typography;

const { Header, Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;

const IconHand = () => <Icon style={{ fontSize: 17 }} component={FaSitemap} ></Icon>
const IconCogs = (props: any) => <Icon {...props} component={FaCog} ></Icon>
const IconTv = (props: any) => <Icon {...props} component={FaTv} ></Icon>
const UnlokProcessoJuridico = (props: any) => <Icon {...props} component={FaUnlockAlt} ></Icon>
const IconFaClipboardList = (props: any) => <Icon {...props} component={FaRegListAlt} ></Icon>
const IconFaPenSquare = (props: any) => <Icon {...props} component={FaPenSquare} ></Icon>

type MenuItem = Required<MenuProps>['items'][number];

const CIRCLE_SIZE = 20;

function getItem(
    permissao: boolean,
    classNamePopUpDrawer: string,
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
): MenuItem {
    let popupClassName = classNamePopUpDrawer;
    return {
        key,
        popupClassName,
        icon,
        children,
        label,
        type,
        permissao: permissao.toString()
    } as MenuItem;
}

const LayoutDashboard: React.FC = ({ children }) => {

    const dispatch = useDispatch();
    const propsState = useSelector((state: stateGlobal) => state.global);
    const history = useHistory();
    const location = useLocation();

    const [collapsed, setCollapsed] = useState(false);
    const [collapsedWidth, setCollapsedWidth] = useState<number>(77);
    const [visibleDrawer, setvisibleDrawer] = useState(false);
    const [visibleDrawerColor, setVisibleDrawerColor] = useState(false);

    const [abrirMenuLateral, setAbrirMenuLateral] = useState<Array<string>>(['']);
    const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState('');

    const [badges, setBadges] = useState<IBadgesLayout>({
        quantidadeMsgAbertas: null,
        quantidadeReceitaIPM: null,
        quantidadeSolicitacoes: undefined,
        quantidadeSolicitacoesRecetias: null,
        quantidadeSolicitacoesSaldoDeContas: undefined,
        quantidadeContasACadastrarSaldoDeContas: undefined,
        quantidadeFontesACadastrarSaldoDeContas: undefined,
        quantidadeInvestimentosACadastrarSaldoDeContas: undefined,
    });

    const [itemsMenuConfiguracaoState, setItemsMenuConfiguracaoState] = useState<MenuProps['items']>([]);
    const refItemsMenuConfiguracaoState = useRef<MenuProps['items']>([]);

    const [itemsMenuPainelState, setItemsMenuPainelState] = useState<MenuItem[]>([]);
    const refItemsMenuPainelState = useRef<MenuItem[]>([]);

    const onCloseDrawerColor = useCallback((): void => {
        setVisibleDrawerColor(false);
    }, []);

    const onAbrirDrawerColor = useCallback((): void => {
        setVisibleDrawerColor(true);
    }, []);

    const onchangeRadioTheme = useCallback((value: any): void => {

        dispatch(GlobalActions.updateTheme(value.target.value));

        history.go(0);
    }, []);

    const signal = axios.CancelToken.source();

    //executa apenas quando desmonta o component
    useEffect(() => () => {
        signal.cancel("Requisicao cancelada!")
    }, []);

    const renderTextAndNumber = useCallback(({ title, value }: { title: string, value?: string | number }) => {

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <span>{title}</span>
                <Badge count={value} style={{ marginLeft: 10, fontWeight: 'bold' }} offset={[0, 0]} size="small" />
            </div>
        )
    }, []);

    const fetchQuantidadesBadges = async () => {
        getMensagensWhatsAppAbertas().then((msgAbertas) => {
            setBadges((prev) => ({
                ...prev,
                quantidadeMsgAbertas: msgAbertas,
            }));
        });

        const [
            receitasIPM,
            solicitacoes,
            qtdSolicitacaoReceitas,
            qtdSolicitacoesSaldoDeContas,
            qtdContasACadastrarSaldoDeContas,
            qtdFontesACadastrarSaldoDeContas,
            qtdInvestimentosACadastrarSaldoDeContas,
        ] = await Promise.all([
            getQuantidadesReceitasIPM(),
            getSolicitacoesNaoAtendidas(),
            getQuantidadeSolicitacaoReceitas(),
            getQuantidadesSolicitacoesSaldoDeContas(),
            getQuantidadesContasACadastrarSaldoDeContas(),
            getQuantidadesFontesACadastrarSaldoDeContas(),
            getQuantidadesInvestimentosACadastrarSaldoDeContas(),
        ]);
        setBadges((prev) => ({
            ...prev,
            quantidadeReceitaIPM: receitasIPM,
            quantidadeSolicitacoes: solicitacoes ?? 0,
            quantidadeSolicitacoesRecetias: qtdSolicitacaoReceitas ?? 0,
            quantidadeSolicitacoesSaldoDeContas: qtdSolicitacoesSaldoDeContas ?? 0,
            quantidadeContasACadastrarSaldoDeContas: qtdContasACadastrarSaldoDeContas ?? 0,
            quantidadeFontesACadastrarSaldoDeContas: qtdFontesACadastrarSaldoDeContas ?? 0,
            quantidadeInvestimentosACadastrarSaldoDeContas: qtdInvestimentosACadastrarSaldoDeContas ?? 0,
        }));
    };

    useEffect(() => {
        let arrayUrl = location.pathname.split("/");

        switch (location.pathname) {
            case "/dashboard":
                dispatch(GlobalActions.updatePositionMenu('1'));
                setAbrirMenuLateral([''])
                break;
            case "/atendimentos":
                dispatch(GlobalActions.updatePositionMenu('2'));
                setAbrirMenuLateral([''])
                break;
            case "/atendimentos/adicionar":
                dispatch(GlobalActions.updatePositionMenu('2'));
                setAbrirMenuLateral([''])
                break;
            case "/atendimentos/editar/" + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('2'));
                setAbrirMenuLateral([''])
                break;
            case "/outros-atendimentos":
                dispatch(GlobalActions.updatePositionMenu('2outrosAtendimentos'));
                setAbrirMenuLateral([''])
                break;
            case "/outros-atendimentos/adicionar":
                dispatch(GlobalActions.updatePositionMenu('2outrosAtendimentos'));
                setAbrirMenuLateral([''])
                break;
            case "/outros-atendimentos/editar/" + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('2outrosAtendimentos'));
                setAbrirMenuLateral([''])
                break;
            case "/usuarios":
                dispatch(GlobalActions.updatePositionMenu('3'));
                setAbrirMenuLateral([''])
                break;
            case "/usuarios/adicionar":
                dispatch(GlobalActions.updatePositionMenu('3'));
                setAbrirMenuLateral([''])
                break;
            case "/contrato":
                dispatch(GlobalActions.updatePositionMenu('4'));
                setAbrirMenuLateral(['subContratos'])
                break;
            case "/contrato/adicionar":
                dispatch(GlobalActions.updatePositionMenu('4'));
                setAbrirMenuLateral(['subContratos'])
                break;
            case "/cidadesUser":
                dispatch(GlobalActions.updatePositionMenu('5'));
                setAbrirMenuLateral([''])
                break;
            case "/cidadesUser/adicionar":
                dispatch(GlobalActions.updatePositionMenu('5'));
                setAbrirMenuLateral([''])
                break;
            case "/associacao":
                dispatch(GlobalActions.updatePositionMenu('6'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/associacao/adicionar":
                dispatch(GlobalActions.updatePositionMenu('6'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/liscodigosms":
                dispatch(GlobalActions.updatePositionMenu('7'));
                setAbrirMenuLateral([''])
                break;
            case "/listcaptacaousuario":
                dispatch(GlobalActions.updatePositionMenu('8'));
                setAbrirMenuLateral([''])
                break;
            case "/listcaptacaousuario/addobrigacao":
                dispatch(GlobalActions.updatePositionMenu('8'));
                setAbrirMenuLateral([''])
                break;
            case "/mensagens":
                dispatch(GlobalActions.updatePositionMenu('9'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/mensagens/add":
                dispatch(GlobalActions.updatePositionMenu('9'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/relatorios/dispositivosativos":
                dispatch(GlobalActions.updatePositionMenu('10'));
                setAbrirMenuLateral(['subRelatorios'])
                break;
            case "/contrato/municipios":
                dispatch(GlobalActions.updatePositionMenu('11'));
                setAbrirMenuLateral([''])
                break;
            case "/contrato/modulo/" + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('12'));
                setAbrirMenuLateral(['subContratos'])
                break;
            case "/pesquisa-satisfacao":
                dispatch(GlobalActions.updatePositionMenu('pesquisaDeSatisfacao'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/pesquisa-satisfacao/criar":
                dispatch(GlobalActions.updatePositionMenu('pesquisaDeSatisfacao'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/contrato/entidades":
                dispatch(GlobalActions.updatePositionMenu('12'));
                setAbrirMenuLateral(['subContratos'])
                break;
            case "/contrato/entidades/gestor/perfil":
                dispatch(GlobalActions.updatePositionMenu('13'));
                setAbrirMenuLateral(['subContratos', 'sub3'])
                break;
            case "/contrato/entidades/gestor/permissao":
                dispatch(GlobalActions.updatePositionMenu('14'));
                setAbrirMenuLateral(['subContratos', 'sub3'])
                break;
            case "/relatorios/pendencias-municipios-por-estado":
                dispatch(GlobalActions.updatePositionMenu('RelatorioPendenciasMunicipios'));
                setAbrirMenuLateral(['subRelatorios'])
                break;
            case "/relatorios/acessos":
                dispatch(GlobalActions.updatePositionMenu('RelAcessos'));
                setAbrirMenuLateral(['subRelatorios'])
                break;
            case "/acessos":
                dispatch(GlobalActions.updatePositionMenu('keyAcessos'));
                setAbrirMenuLateral([''])
                break;
            case '/acessos/' + arrayUrl[2]:
                dispatch(GlobalActions.updatePositionMenu('keyAcessos'));
                setAbrirMenuLateral(['']);
                break;
            case "/integracoes":
                dispatch(GlobalActions.updatePositionMenu('integracoes'));
                setAbrirMenuLateral(['outros'])
                break;
            case '/integracoes/' + arrayUrl[2]:
                dispatch(GlobalActions.updatePositionMenu('integracoes'));
                setAbrirMenuLateral(['outros'])
            case '/integracoes/sicon-personalizacao/' + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('integracoes'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/solicitacoes-de-ativacao":
                dispatch(GlobalActions.updatePositionMenu('solicitacoesAtivacao'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/solicitacoes-de-ativacao/gerenciar/" + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('solicitacoesAtivacao'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/ativacoes":
                dispatch(GlobalActions.updatePositionMenu('manutencaoAtivacoes'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/ativacoes/manutencao":
            case "/ativacoes/manutencao/" + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('manutencaoAtivacoes'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/contas-a-cadastrar":
                dispatch(GlobalActions.updatePositionMenu('contasACadastrar'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/fontes-a-cadastrar":
                dispatch(GlobalActions.updatePositionMenu('fontesACadastrar'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/investimentos-a-cadastrar":
                dispatch(GlobalActions.updatePositionMenu('investimentosACadastrar'));
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case "/contrato/solicitacoes-de-upgrade":
                dispatch(GlobalActions.updatePositionMenu('solicitacoesDeUpgrade'));
                setAbrirMenuLateral(['subContratos'])
                break;
            case "/whatsapp-mensagens":
                dispatch(GlobalActions.updatePositionMenu('15'));
                setAbrirMenuLateral([''])
                break;
            case "/configuracoes-de-receitas":
                dispatch(GlobalActions.updatePositionMenu('16'));
                setAbrirMenuLateral(['outros'])
                break;
            case "/recuperacao-receitas":
                dispatch(GlobalActions.updatePositionMenu('17'));
                setAbrirMenuLateral([''])
                break;
            case "/propostas-comerciais":
            case "/propostas-comerciais/cadastrar":
            case "/propostas-comerciais/editar/" + arrayUrl[3]:
                dispatch(GlobalActions.updatePositionMenu('listarPropostasComerciais'));
                setAbrirMenuLateral(['subPropostas']);
                break;
            case "/propostas-comerciais/configuracoes":
                dispatch(GlobalActions.updatePositionMenu('configurarPlanosPropostas'));
                setAbrirMenuLateral(['subPropostas']);
                break;
            case "/inteligencia-artificial":
                dispatch(GlobalActions.updatePositionMenu('inteligenciaArtificial'));
                setAbrirMenuLateral(['outros'])
                break;

            default:
                dispatch(GlobalActions.updatePositionMenu(''));
                break;
        }
    }, [location.pathname]);

    useEffect(() => {
        fetchQuantidadesBadges();
        window.addEventListener('atualizarContagemBalon', fetchQuantidadesBadges);
        window.addEventListener('atualizarContagemBalonIPM', fetchQuantidadesBadges);
        return () => {
            window.removeEventListener('atualizarContagemBalon', fetchQuantidadesBadges);
            window.removeEventListener('atualizarContagemBalonIPM', fetchQuantidadesBadges);
        };
    }, []);

    useEffect(() => {
        const requestAsync = async () => {
            try {

                let dataUsuario = getUsuario();
                if (dataUsuario) {
                    let arrayUrl = dataUsuario.nome.split(" ")
                    setNomeUsuarioLogado(arrayUrl[0])
                }

                let isDrawerOpned = '';

                if (typeof window !== 'undefined') {
                    if (window.innerWidth < 768) {
                        isDrawerOpned = 'dspclassMenuPopUpDraweer';
                        setCollapsedWidth(0);
                    }
                }

                if (refItemsMenuConfiguracaoState.current && refItemsMenuConfiguracaoState.current.length === 0) {

                    const itemsMenuConfiguracao: MenuProps['items'] = [
                        getItem(true, isDrawerOpned, 'Configurações', '3', <IconCogs />),
                        getItem(true, isDrawerOpned, 'Tema', '4', <IconTv />),
                        getItem(true, isDrawerOpned, 'Sair', '5', <LogoutOutlined />),
                    ];

                    const menuConfig = itemsMenuConfiguracao.filter((element: any) => element?.permissao === 'true')

                    setItemsMenuConfiguracaoState(menuConfig)
                }

                if (refItemsMenuPainelState.current && refItemsMenuPainelState.current.length === 0) {


                    const itemsMenuPainel: MenuItem[] = [
                        getItem(true, isDrawerOpned, 'Dashboard', '1', <LineChartOutlined />),
                        getItem(true, isDrawerOpned, 'Atendimentos', '2', <TeamOutlined />),
                        getItem(true, isDrawerOpned, 'Outros Atendimentos', '2outrosAtendimentos', <TeamOutlined />),
                        getItem(
                            true,
                            isDrawerOpned,
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                            }}>
                                <span>WhatsApp Mensagens</span>
                                <Badge
                                    count={badges.quantidadeMsgAbertas}
                                    overflowCount={999}
                                    style={{
                                        backgroundColor: '#52c41a',
                                        color: '#fff',
                                        borderColor: '#52c41a',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        minWidth: '20px',
                                        height: '20px',
                                        borderRadius: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 6px',
                                        lineHeight: '20px',
                                        marginLeft: '10px'
                                    }}
                                />
                            </div>,
                            '15',
                            <WhatsAppOutlined />
                        ),
                        getItem(
                            true,
                            isDrawerOpned,
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                            }}>
                                <span>Recuperação de Receitas</span>
                                <Badge
                                    count={badges.quantidadeSolicitacoesRecetias}
                                    overflowCount={999}
                                    style={{
                                        backgroundColor: '#52c41a',
                                        color: '#fff',
                                        borderColor: '#52c41a',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        minWidth: '20px',
                                        height: '20px',
                                        borderRadius: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 6px',
                                        lineHeight: '20px',
                                        marginLeft: '10px'
                                    }}
                                />
                            </div>,
                            '17',
                            <FaDollarSign />
                        ),
                        getItem(true, isDrawerOpned, 'Usuários', '3', <UserOutlined />),
                        getItem(true, isDrawerOpned, 'Contratos', 'subContratos', <SolutionOutlined />, [
                            getItem(true, isDrawerOpned, 'Listagem de Contratos', '4', <FaListAlt />),
                            getItem(true, isDrawerOpned, 'Entidades', '12', <FaListAlt />),
                            getItem(true, isDrawerOpned, 'Painel Gestor', 'sub3', <FaListAlt />, [
                                getItem(true, isDrawerOpned, 'Perfis de Usuários', '13', <FaUserAlt />),
                                getItem(true, isDrawerOpned, 'Permissões de Usuários', '14', <FaLockOpen />),
                            ]),
                            getItem(true, isDrawerOpned, renderTextAndNumber({ title: 'Solicitações de Upgrade', value: badges.quantidadeSolicitacoes }), 'solicitacoesDeUpgrade', <img
                                src={LogoPNG}
                                alt={'Solicitação de upgrade'}
                                style={{
                                    width: '22px',
                                    height: '22px',
                                    marginRight: -5,
                                    marginLeft: -2,
                                    filter: 'brightness(0) saturate(100%) invert(81%) sepia(1%) saturate(1355%) hue-rotate(162deg) brightness(96%) contrast(93%)'
                                    ,
                                }}
                            // className={className}
                            />),
                        ]),
                        getItem(true, isDrawerOpned, 'Propostas', "subPropostas", <FileProtectOutlined />, [
                            getItem(true, isDrawerOpned, 'Listar Propostas', 'listarPropostasComerciais', <FaListAlt />),
                            getItem(true, isDrawerOpned, 'Configurações', 'configurarPlanosPropostas', <SettingOutlined />),
                        ]),
                        getItem(true, isDrawerOpned, 'Acessos', 'keyAcessos', <SolutionOutlined />),
                        getItem(true, isDrawerOpned, 'Municípios por Contrato', '11', <IconFaClipboardList />),
                        getItem(true, isDrawerOpned, 'Processos Jurídicos (Senha)', '5', <UnlokProcessoJuridico />),
                        getItem(true, isDrawerOpned, 'Códigos Autenticação', '7', <MobileOutlined />),
                        getItem(true, isDrawerOpned, 'Relatórios', 'subRelatorios', <MenuOutlined />, [
                            getItem(true, isDrawerOpned, 'Acessos', 'RelAcessos', <FileTextOutlined />),
                            getItem(true, isDrawerOpned, 'Dispositivos Ativos', '10', <MobileOutlined />),
                            getItem(true, isDrawerOpned, 'Pendências de Municípios', 'RelatorioPendenciasMunicipios', <FileTextOutlined />),
                        ]),
                        getItem(
                            true,
                            isDrawerOpned,
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <span>Saldo de Contas</span>
                                {(badges.quantidadeSolicitacoesSaldoDeContas !== undefined && badges.quantidadeSolicitacoesSaldoDeContas > 0) && (
                                    <div
                                        style={{
                                            backgroundColor: '#ff4d4f',
                                            width: 10,
                                            height: 10,
                                            borderRadius: 50
                                        }}
                                    />
                                )}
                            </div>,
                            'saldoDeContas',
                            <FaCreditCard />,
                            [
                                getItem(
                                    true,
                                    isDrawerOpned,
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                        <span>Solicitações de Ativação</span>
                                        <Badge
                                            count={badges.quantidadeSolicitacoesSaldoDeContas}
                                            overflowCount={999}
                                            style={{
                                                backgroundColor: '#ff4d4f',
                                                color: '#fff',
                                                borderColor: '#ff4d4f',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                minWidth: '20px',
                                                height: '20px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 6px',
                                                lineHeight: '20px',
                                                marginLeft: '10px'
                                            }}
                                        />
                                    </div>,
                                    'solicitacoesAtivacao',
                                    <FileTextOutlined />
                                ),
                                getItem(
                                    true,
                                    isDrawerOpned,
                                    'Manutenção de Ativações',
                                    'manutencaoAtivacoes',
                                    <FaLandmark />
                                ),
                                getItem(
                                    true,
                                    isDrawerOpned,
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                        <span>Contas a cadastrar</span>
                                        <Badge
                                            count={badges.quantidadeContasACadastrarSaldoDeContas}
                                            overflowCount={999}
                                            style={{
                                                backgroundColor: '#ff4d4f',
                                                color: '#fff',
                                                borderColor: '#ff4d4f',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                minWidth: '20px',
                                                height: '20px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 6px',
                                                lineHeight: '20px',
                                                marginLeft: '10px'
                                            }}
                                        />
                                    </div>,
                                    'contasACadastrar',
                                    <FaPlusCircle />
                                ),
                                getItem(
                                    true,
                                    isDrawerOpned,
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                        <span>Fontes a cadastrar</span>
                                        <Badge
                                            count={badges.quantidadeFontesACadastrarSaldoDeContas}
                                            overflowCount={999}
                                            style={{
                                                backgroundColor: '#ff4d4f',
                                                color: '#fff',
                                                borderColor: '#ff4d4f',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                minWidth: '20px',
                                                height: '20px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 6px',
                                                lineHeight: '20px',
                                                marginLeft: '10px'
                                            }}
                                        />
                                    </div>,
                                    'fontesACadastrar',
                                    <FaPlusCircle />
                                ),
                                getItem(
                                    true,
                                    isDrawerOpned,
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                        <span>Invest. a cadastrar</span>
                                        <Badge
                                            count={badges.quantidadeInvestimentosACadastrarSaldoDeContas}
                                            overflowCount={999}
                                            style={{
                                                backgroundColor: '#ff4d4f',
                                                color: '#fff',
                                                borderColor: '#ff4d4f',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                minWidth: '20px',
                                                height: '20px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 6px',
                                                lineHeight: '20px',
                                                marginLeft: '10px'
                                            }}
                                        />
                                    </div>,
                                    'investimentosACadastrar',
                                    <FaPlusCircle />
                                ),
                            ]
                        ),
                        getItem(
                            true,
                            isDrawerOpned,
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <span>Outros</span>
                                {(badges.quantidadeReceitaIPM !== null && badges.quantidadeReceitaIPM > 0) && (
                                    <div
                                        style={{
                                            backgroundColor: '#52c41a',
                                            width: 10,
                                            height: 10,
                                            borderRadius: 50
                                        }}
                                    >
                                    </div>
                                )}
                            </div>,
                            'outros',
                            <MenuOutlined />,
                            [
                                getItem(
                                    true,
                                    isDrawerOpned,
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                        <span>Config. Receitas</span>
                                        <Badge
                                            count={badges?.quantidadeReceitaIPM}
                                            overflowCount={999}
                                            style={{
                                                backgroundColor: '#52c41a',
                                                color: '#fff',
                                                borderColor: '#52c41a',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                minWidth: '20px',
                                                height: '20px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 6px',
                                                lineHeight: '20px',
                                                marginLeft: '10px'
                                            }}
                                        />
                                    </div>,
                                    '16',
                                    <ToolOutlined />
                                ),
                                getItem(true, isDrawerOpned, 'Mensagens', '9', <MessageOutlined />),
                                getItem(true, isDrawerOpned, 'Associações', '6', <IconHand />),
                                getItem(true, isDrawerOpned, 'Integrações', 'integracoes', <IconHand />),
                                getItem(true, isDrawerOpned, 'Pesquisa de Satisfação', 'pesquisaDeSatisfacao', <IconFaPenSquare />),
                                getItem(true, isDrawerOpned, 'Inteligência Artificial', 'inteligenciaArtificial', <RobotOutlined />),
                            ]),
                    ];

                    //permissao para itens do painel
                    const menuPainel = itemsMenuPainel.filter((element: any) => element?.permissao === 'true')

                    //permissao sub para itens do painel (collapse)
                    menuPainel.map((element: any) => {
                        if (element?.children && element?.children.length > 0) {
                            const subPermissoions = element?.children.filter((subElement: any) => subElement?.permissao === 'true')
                            element.children = subPermissoions
                            return element
                        }
                        return element
                    })


                    setItemsMenuPainelState(menuPainel)

                }



            } catch (error) {
                let msgErro: any = (error as Error);
                notification.error({
                    message: 'Erro',
                    description:
                        msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Erro entre em contato com o suporte!',
                });
            }
        }

        requestAsync();

    }, [badges]);

    const clickNavigateMenuLateral = useCallback(async (rota: string) => {
        await fetchQuantidadesBadges();
        history.push(rota);
        setvisibleDrawer(false);
    }, []);

    const clickMenuPrinciopal = useCallback(({ key }: any): void => {
        dispatch(GlobalActions.updatePositionMenu(key));

        switch (key) {
            case '1':
                clickNavigateMenuLateral("/dashboard");
                setAbrirMenuLateral([''])
                break;
            case '2':
                clickNavigateMenuLateral('/atendimentos');
                setAbrirMenuLateral([''])
                break;
            case '2outrosAtendimentos':
                clickNavigateMenuLateral('/outros-atendimentos');
                setAbrirMenuLateral([''])
                break;
            case '3':
                let arrayUrl = window.location.pathname.split("/");

                if (arrayUrl[1] === 'usuarios' && !arrayUrl[2]) {

                } else {

                    let dadosLocalStorage: string | null = localStorage.getItem('@GovFacil:ListUsersContrato');
                    let localUserData: any = null;
                    if (typeof dadosLocalStorage == 'string') {
                        localUserData = JSON.parse(dadosLocalStorage);
                    }

                    if (localUserData) {
                        localStorage.removeItem('@GovFacil:ListUsersContrato');
                    }
                    clickNavigateMenuLateral('/usuarios');
                    setAbrirMenuLateral([''])
                }
                setvisibleDrawer(false);
                break;
            case '4':
                clickNavigateMenuLateral('/contrato');
                setAbrirMenuLateral(['subContratos'])
                break;
            case '5':
                clickNavigateMenuLateral('/cidadesUser');
                setAbrirMenuLateral([''])
                break;
            case '6':
                clickNavigateMenuLateral('/associacao');
                setAbrirMenuLateral(['outros'])
                break;
            case '7':
                clickNavigateMenuLateral('/liscodigosms');
                setAbrirMenuLateral([''])
                break;
                // case '8':
                //     clickNavigateMenuLateral('/listcaptacaousuario');
                setAbrirMenuLateral([''])
            //     break;
            case '9':
                clickNavigateMenuLateral('/mensagens');
                setAbrirMenuLateral(['outros'])
                break;
            case '10':
                clickNavigateMenuLateral('/relatorios/dispositivosativos');
                setAbrirMenuLateral(['subRelatorios'])
                break;
            case '11':
                clickNavigateMenuLateral('/contrato/municipios');
                setAbrirMenuLateral([''])
                break;
            case 'pesquisaDeSatisfacao':
                clickNavigateMenuLateral('/pesquisa-satisfacao');
                setAbrirMenuLateral(['outros'])
                break;
            case '12':
                clickNavigateMenuLateral('/contrato/entidades');
                setAbrirMenuLateral(['subContratos'])
                break;
            case '13':
                clickNavigateMenuLateral('/contrato/entidades/gestor/perfil');
                setAbrirMenuLateral(['subContratos'])
                break;
            case '14':
                clickNavigateMenuLateral('/contrato/entidades/gestor/permissao');
                setAbrirMenuLateral(['subContratos'])
                break;
            case 'RelatorioPendenciasMunicipios':
                clickNavigateMenuLateral('/relatorios/pendencias-municipios-por-estado');
                setAbrirMenuLateral(['subRelatorios'])
                break;
            case 'RelAcessos':
                clickNavigateMenuLateral('/relatorios/acessos');
                setAbrirMenuLateral(['subRelatorios'])
                break;
            case 'keyAcessos':
                clickNavigateMenuLateral('/acessos');
                setAbrirMenuLateral([])
                break;
            case 'integracoes':
                let dadosLocalStorage: string | null = localStorage.getItem('@GovFacil:ListInteracoesByMunicipio');
                let localUserData: any = null;
                if (typeof dadosLocalStorage == 'string') {
                    localUserData = JSON.parse(dadosLocalStorage);
                }

                if (localUserData) {
                    localStorage.removeItem('@GovFacil:ListInteracoesByMunicipio');
                }
                clickNavigateMenuLateral('/integracoes');
                setAbrirMenuLateral([''])
                break;
            case 'solicitacoesAtivacao':
                clickNavigateMenuLateral('/solicitacoes-de-ativacao');
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case 'manutencaoAtivacoes':
                clickNavigateMenuLateral('/ativacoes');
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case 'contasACadastrar':
                clickNavigateMenuLateral('/contas-a-cadastrar');
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case 'fontesACadastrar':
                clickNavigateMenuLateral('/fontes-a-cadastrar');
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case 'investimentosACadastrar':
                clickNavigateMenuLateral('/investimentos-a-cadastrar');
                setAbrirMenuLateral(['saldoDeContas'])
                break;
            case 'solicitacoesDeUpgrade':
                clickNavigateMenuLateral('/contrato/solicitacoes-de-upgrade');
                setAbrirMenuLateral(['subContratos'])
                break;
            case '15':
                clickNavigateMenuLateral('/whatsapp-mensagens');
                setAbrirMenuLateral([''])
                break;
            case '16':
                clickNavigateMenuLateral('/configuracoes-de-receitas');
                setAbrirMenuLateral(['outros'])
                break;
            case '17':
                clickNavigateMenuLateral('/recuperacao-receitas');
                setAbrirMenuLateral([''])
                break;
            case 'listarPropostasComerciais':
                clickNavigateMenuLateral('/propostas-comerciais');
                setAbrirMenuLateral(['subPropostas']);
                break;
            case 'configurarPlanosPropostas':
                clickNavigateMenuLateral('/propostas-comerciais/configuracoes');
                setAbrirMenuLateral(['subPropostas']);
                break;
            case 'inteligenciaArtificial':
                clickNavigateMenuLateral('/inteligencia-artificial');
                setAbrirMenuLateral(['outros']);
                break;
            default:
                break;
        }

    }, []);

    const toggle = useCallback((): void => {
        if (collapsedWidth === 0) {
            setvisibleDrawer(!visibleDrawer);
        } else {
            setCollapsed(!collapsed);
        }
    }, [collapsedWidth, visibleDrawer, collapsed]);

    const onCollapse = useCallback((collapsedVal): void => {
        if (!collapsed) {
            setCollapsed(collapsedVal);
            setCollapsedWidth(77);
        } else {
            setCollapsed(collapsedVal);
            setCollapsedWidth(0);
        }
    }, [collapsed, collapsedWidth]);

    const onCloseDrawer = useCallback((): void => {
        setvisibleDrawer(false);
    }, []);

    const clickMenuDireitoConfiguracoes = useCallback((): void => {
        history.push("/configuracoesdosistema");
    }, []);

    const clickMenuDireitoSair = useCallback((): void => {
        history.push("/");
        localStorage.removeItem('@GovFacil:token');
        dispatch(LoginActions.loginAlterSingOut());
    }, []);

    const onClickMenuConfiguracoes = useCallback((e: any): void => {
        switch (e.key) {
            case '3':
                clickMenuDireitoConfiguracoes();
                break;
            case '4':
                onAbrirDrawerColor();
                break;
            case '5':
                clickMenuDireitoSair();
                break;

            default:
                break;
        }

    }, []);

    return (
        <>
            <Drawer
                placement="left"
                closable={false}
                onClose={onCloseDrawer}
                open={visibleDrawer}
                key="left"
                style={{ padding: 0 }}
            // bodyStyle={{background:'red'}}
            >
                <img className="logoimgMenuResponsive" style={{ marginBottom: 10, marginTop: -10 }} src={ImagemLogo}></img>
                <Menu mode="inline"
                    onClick={position => { clickMenuPrinciopal(position) }}
                    defaultSelectedKeys={[propsState.positionMenu]}
                    selectedKeys={[propsState.positionMenu]}
                    forceSubMenuRender={false}
                    triggerSubMenuAction="click"
                    // style={{ width: 262, marginLeft: -30, padding: 0 }}
                    onOpenChange={(openKeys) => setAbrirMenuLateral(openKeys)}
                    className="DraerwMenuPrinmcipal"
                    // theme="dark"
                    items={itemsMenuPainelState}
                    style={{
                        marginLeft: -24,
                        marginRight: -24,
                        // padding: 0
                    }}
                // openKeys={abrirMenuLateral}
                />
            </Drawer>
            <Layout style={{ minHeight: '100vh' }}>
                <Sider
                    width={301}
                    collapsedWidth={collapsedWidth}
                    breakpoint="md"
                    onBreakpoint={broken => {
                        onCollapse(broken);
                    }}
                    collapsed={collapsed}
                    style={{
                        overflow: 'auto',
                        height: '100vh',
                        position: 'fixed',
                        left: 0,
                        scrollBehavior: 'smooth'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            paddingTop: 10,
                            paddingBottom: 10
                        }}
                    >
                        {/* <div className="logo" /> */}
                        {collapsed ?
                            <img className="iconePGimg" src={ImagemIcone}></img>
                            : <img className="logoimg" src={
                                ImagemLogoDark
                                // propsState.theme === 'light' ? GIFLogo : GIFLogoDark
                            }></img>}
                    </div>
                    <Menu theme="dark" mode="inline"
                        onClick={position => { clickMenuPrinciopal(position) }}
                        defaultSelectedKeys={[propsState.positionMenu]}
                        selectedKeys={[propsState.positionMenu]}
                        style={{}}
                        items={itemsMenuPainelState}
                        openKeys={abrirMenuLateral}
                        onOpenChange={(openKeys) => setAbrirMenuLateral(openKeys)}
                    />

                </Sider>
                <Layout className={collapsed ? "siteLayout2" : "siteLayout"}>
                    <Header className="site-layout-sub-header-background"
                        style={{
                            position: 'fixed',
                            zIndex: 2,
                            padding: 0,
                            width: collapsed ? 'calc(100% - 75px)' : 'calc(100% - 301px)'
                        }}
                    >
                        <div style={{ float: "left" }}>
                            {React.createElement(
                                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                                {
                                    className: "trigger",
                                    onClick: toggle
                                }
                            )}
                        </div>

                        <Dropdown
                            // onClick={handleButtonClick}
                            trigger={['click']}
                            className="dropDownMenu"
                            menu={{
                                items: itemsMenuConfiguracaoState,
                                onClick: onClickMenuConfiguracoes,
                            }}
                        >
                            <Button
                                style={{
                                    // marginRight: 10,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}
                                type="text">
                                {
                                    collapsedWidth !== 0 &&
                                    <Text
                                        style={{
                                            marginRight: '6px'
                                        }}
                                    >{nomeUsuarioLogado}</Text>
                                }
                                <Avatar size={28} icon={<UserOutlined />} />
                            </Button>
                        </Dropdown>

                    </Header>
                    <Content className="site-layout-background" >
                        {children}
                    </Content>
                    <Footer
                        style={{ textAlign: 'center', marginTop: -10, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: 0, paddingRight: 0 }}
                    >
                        Desenvolvido por <img style={{
                            width: 90,
                            marginLeft: 5
                        }} src={ImagemGovfacil} />
                    </Footer>
                </Layout>
            </Layout>
            {/* Drawer para alterar cor do sistema */}
            <Drawer
                title="Tema do sistema"
                placement="right"
                closable={false}
                onClose={onCloseDrawerColor}
                open={visibleDrawerColor}
            >
                <Radio.Group onChange={onchangeRadioTheme} defaultValue={propsState.theme} size="large">
                    <Radio.Button value="light">Light</Radio.Button>
                    <Radio.Button value="dark">Dark</Radio.Button>
                    {/* <Radio.Button value="c">Beijing</Radio.Button> */}
                </Radio.Group>
            </Drawer>
        </>
    );
};

export default LayoutDashboard;
